// extracted by mini-css-extract-plugin
export default {"container":"InputWithSearch_container__u6hp5","search":"InputWithSearch_search__S0nqg"};